import * as React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useMediaIsDesktop } from '@collaborator/npm_modules/dist/components/media';
import app from 'src/js/App';
import { LangsMenuToggler } from './LangsMenuToggler';
import { LangsMenuList } from './LangsMenuList';

var LangsMenu = function LangsMenu(_ref) {
  var submenu = _ref.submenu,
      setSubmenu = _ref.setSubmenu;
  var isDesktop = useMediaIsDesktop();

  if (isDesktop) {
    return /*#__PURE__*/React.createElement(Dropdown, {
      drop: "left",
      className: "dropdown dropdown-flat-list__item",
      show: submenu,
      onToggle: function onToggle(isOpenLocal, event, metadata) {
        if (metadata.source === 'rootClose') {
          setSubmenu(false);
        } else {
          setSubmenu(true);
        }
      }
    }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      variant: "link",
      id: "dropdown-langs-button",
      className: "gap-0"
    }, /*#__PURE__*/React.createElement(LangsMenuToggler, null)), /*#__PURE__*/React.createElement(Dropdown.Menu, {
      className: "dropdown-menu dropdown-flat-submenu"
    }, /*#__PURE__*/React.createElement(LangsMenuList, null)));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "dropdown dropdown-flat-list__item"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setSubmenu(true);
    }
  }, /*#__PURE__*/React.createElement(LangsMenuToggler, null)), submenu ? /*#__PURE__*/React.createElement("ul", {
    className: "dropdown-menu dropdown-flat-submenu show"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setSubmenu(false);
    },
    type: "button",
    className: "dropdown-flat-submenu__item dropdown-flat-submenu_toggle"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-angle-left"
  }), app.tForReact('catalog_channel_list', 'Language'))), /*#__PURE__*/React.createElement(LangsMenuList, null)) : null);
};

export { LangsMenu };